var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconFullscreenComponent(props, ref) {
  var prefixFromContext = useContext(Context).prefix;
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    prefixFromProps = props.prefix,
    _b = props.width,
    width = _b === void 0 ? '1em' : _b,
    _c = props.height,
    height = _c === void 0 ? '1em' : _c,
    _d = props.useCurrentColor,
    useCurrentColor = _d === void 0 ? true : _d,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  var prefix = prefixFromProps || prefixFromContext || 'arco';
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: "".concat(prefix, "-icon ").concat(prefix, "-icon-fullscreen ").concat(className),
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: useCurrentColor ? 'currentColor' : '#000',
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9987 3.33415V5.00043C14.9987 5.18453 14.8494 5.33377 14.6653 5.33377H13.9987C13.8146 5.33377 13.6653 5.18453 13.6653 5.00043V3.33415C13.6653 3.15005 13.5161 3.00081 13.332 3.00081H11.6657C11.4816 3.00081 11.3324 2.85157 11.3324 2.66748V2.00081C11.3324 1.81672 11.4816 1.66748 11.6657 1.66748H13.332C14.2525 1.66748 14.9987 2.41367 14.9987 3.33415ZM1.00122 12.6658V10.9996C1.00122 10.8155 1.15046 10.6662 1.33455 10.6662H2.00122C2.18532 10.6662 2.33455 10.8155 2.33455 10.9996L2.33455 12.6658C2.33455 12.8499 2.48379 12.9992 2.66789 12.9992H4.33417C4.51827 12.9992 4.66751 13.1484 4.66751 13.3325V13.9992C4.66751 14.1833 4.51827 14.3325 4.33417 14.3325L2.66789 14.3325C1.74741 14.3325 1.00122 13.5863 1.00122 12.6658ZM1.33455 5.3343C1.15046 5.3343 1.00122 5.18506 1.00122 5.00097V3.33468C1.00122 2.41421 1.74741 1.66802 2.66789 1.66802L4.33417 1.66802C4.51827 1.66802 4.66751 1.81725 4.66751 2.00135V2.66802C4.66751 2.85211 4.51827 3.00135 4.33417 3.00135H2.66789C2.48379 3.00135 2.33455 3.15059 2.33455 3.33468L2.33455 5.00097C2.33455 5.18506 2.18532 5.3343 2.00122 5.3343H1.33455ZM14.9987 12.6657V10.9995C14.9987 10.8154 14.8494 10.6661 14.6653 10.6661H13.9987C13.8146 10.6661 13.6653 10.8154 13.6653 10.9995V12.6657C13.6653 12.8498 13.5161 12.9991 13.332 12.9991H11.6657C11.4816 12.9991 11.3324 13.1483 11.3324 13.3324V13.9991C11.3324 14.1832 11.4816 14.3324 11.6657 14.3324H13.332C14.2525 14.3324 14.9987 13.5862 14.9987 12.6657ZM5.00058 4.33355C4.08011 4.33355 3.33391 5.07974 3.33391 6.00022V9.99946C3.33391 10.9199 4.08011 11.6661 5.00058 11.6661H10.9996C11.9201 11.6661 12.6663 10.9199 12.6663 9.99946V6.00022C12.6663 5.07975 11.9201 4.33355 10.9996 4.33355H5.00058ZM4.66725 6.00022C4.66725 5.81613 4.81649 5.66689 5.00058 5.66689H10.9996C11.1837 5.66689 11.3329 5.81612 11.3329 6.00022V9.99946C11.3329 10.1836 11.1837 10.3328 10.9996 10.3328H5.00058C4.81649 10.3328 4.66725 10.1836 4.66725 9.99946V6.00022Z",
    fillOpacity: "1"
  }));
}
var IconFullscreen = /*#__PURE__*/React.forwardRef(IconFullscreenComponent);
export default IconFullscreen;